import api from './api';

export interface RespostaDeAcesso {
  access_token: string;
  message: string;
}

export const impersonacaoService = {
  async entrar(userId: number): Promise<RespostaDeAcesso> {
    const { data } = await api.post<RespostaDeAcesso>(`/usuarios/${userId}/acessar-como`);
    return data;
  },

  async voltar(): Promise<RespostaDeAcesso> {
    const { data } = await api.post<RespostaDeAcesso>('/auth/voltar-ao-meu-usuario');
    return data;
  },
};

export default impersonacaoService;
